/**
 * Optimisation task details.
 */
export class OptTaskDetails {
  storeId: string;
  storeName: string;
  status: string;
  lastComplete: string;

  /**
   * @param storeId the identity of the store.
   * @param storeName - the name of the store.
   * @param status - the status of the task.
   * @param lastComplete - the last time the task was completed successfully.
   */
  constructor(storeId: string, storeName: string, status: string, lastComplete: string) {
    this.storeId = storeId;
    this.storeName = storeName;
    this.status = status;
    this.lastComplete = lastComplete;
  }
}
